export default class Filter {
  static get URL_PARAM_FILTER() {
    return 'filter'
  }

  static get TYPE_EQ() {
    return 'eq'
  }

  static get TYPE_NEQ() {
    return 'neq'
  }

  static get TYPE_LT() {
    return 'lt'
  }

  static get TYPE_LTE() {
    return 'lte'
  }

  static get TYPE_GT() {
    return 'gt'
  }

  static get TYPE_GTE() {
    return 'gte'
  }

  static get TYPE_IN() {
    return 'in'
  }

  static get TYPE_NOT_IN() {
    return 'notIn'
  }

  static get TYPE_LIKE() {
    return 'like'
  }

  static get TYPE_NOT_LIKE() {
    return 'notLike'
  }

  static get TYPE_STRING() {
    return 'string'
  }

  static get TYPES() {
    return {
      [Filter.TYPE_EQ]: Filter.TYPE_EQ,
      [Filter.TYPE_NEQ]: Filter.TYPE_NEQ,
      [Filter.TYPE_LT]: Filter.TYPE_LT,
      [Filter.TYPE_LTE]: Filter.TYPE_LTE,
      [Filter.TYPE_GT]: Filter.TYPE_GT,
      [Filter.TYPE_GTE]: Filter.TYPE_GTE,
      [Filter.TYPE_IN]: Filter.TYPE_IN,
      [Filter.TYPE_NOT_IN]: Filter.TYPE_NOT_IN,
      [Filter.TYPE_LIKE]: Filter.TYPE_LIKE,
      [Filter.TYPE_NOT_LIKE]: Filter.TYPE_NOT_LIKE,
      [Filter.TYPE_STRING]: Filter.TYPE_STRING,
    }
  }

  constructor(criteria) {
    this._filters = {}
    this._criteria = criteria

    if (this._criteria) {
      this.parseCriteria()
    }
  }

  parseCriteria() {
    const paramsFilter = this._criteria.match(
      // eslint-disable-next-line no-useless-escape
      new RegExp(`${Filter.URL_PARAM_FILTER}=(.+?)\/`, 'i'),
    )

    if (paramsFilter && paramsFilter[1]) {
      const params = paramsFilter[1].split(';')
      let param

      // eslint-disable-next-line guard-for-in
      for (const k in params) {
        param = params[k].split(':')

        if (Array.isArray(param) && param.length > 1) {
          this._filters[param[0]] = {
            type:
              param[2] && Filter.TYPES.hasOwnProperty(param[2]) ? param[2] : '',
            values: param[1].split(','),
          }
        }
      }
    }
  }

  getFilters() {
    return this._filters
  }

  getFiltersQuery() {
    const filters = this._filters

    if (!Object.keys(filters).length) {
      return ''
    }

    let query = ''

    Object.keys(filters).forEach((key, index) => {
      if (index > 0) {
        query += '&'
      } else {
        query = '?'
      }

      filters[key].values
        .filter(value => !!value)
        .forEach((value, valueIndex) => {
          query += `${valueIndex > 0 ? '&' : ''}`
          query += `${key}`
          query += `${filters[key].type !== 'string' ? `[${valueIndex}]` : ''}`
          query += `=${value}`
        })
    })

    return query
  }

  setFilter(field, value, type) {
    if (typeof field !== 'string') {
      throw new Error('Param [field] must be a string')
    }

    if (type && !Filter.TYPES.hasOwnProperty(type)) {
      throw new Error('Param [type] is undefined')
    }

    this._filters[field] = {
      type: type || '',
      values: !Array.isArray(value) ? [value] : value,
    }
  }

  clearFilter(field) {
    delete this._filters[field]

    return this
  }

  clearAll() {
    this._filters = {}

    return this
  }

  getCriteria() {
    if (Object.keys(this._filters).length < 1) {
      return ''
    }

    const filterArray = []
    let valueString
    let typeString

    // eslint-disable-next-line guard-for-in
    for (const key in this._filters) {
      valueString = this._filters[key].values.filter(value => !!value).join(',')
      typeString = this._filters[key].type

      filterArray.push(
        `${key}:${valueString}${typeString ? ':' : ''}${typeString}`,
      )
    }

    return `${Filter.URL_PARAM_FILTER}=${filterArray.join(';')}/`
  }

  getApiCriteria() {
    if (Object.keys(this._filters).length < 1) {
      return ''
    }

    const filterArray = []
    let valueString
    let typeString

    // eslint-disable-next-line guard-for-in
    for (const key in this._filters) {
      valueString = this._filters[key].values.filter(value => !!value).join(',')
      typeString = this._filters[key].type

      filterArray.push(
        `${key}:${valueString}${typeString ? ':' : ''}${typeString}`,
      )
    }

    return `${Filter.URL_PARAM_FILTER}=${filterArray.join(';')}`
  }
}
